import * as React from 'react';
import { Field } from 'formik';
import Input from '~/common/controls/Input';
import Button from '~/common/elements/mobile/Button';
import { buttonSize, buttonStyle } from '~/common/elements/mobile/consts';
import BodyWrapper from '~/common/elements/mobile/BodyWrapper';

export class sendToName {
  static MAIL = 'to-mail';
  static SMS = 'to-sms';
}

const PaycodesFormEmailOrSms = (props) => {
  const { sendTo, handleSends, options, isErrEmail, isErrPhone, infoMessage } = props;

  switch (sendTo) {
    case sendToName.MAIL:
      return (
        <>
          <Field
            name="email"
            placeholder="Input Email"
            label="Email"
            component={Input}
            className="input input--sm input--withdrop"
            isSearchable={false}
            customStyle={{backgroundColor: '#eee', paddingLeft: 10}}
          />

          <span style={{color: 'white'}}>{infoMessage.message}</span>

          <div className="m__foot__btns__dbl --gtg">
            < Button
              title={isErrEmail ? 'Enter a Valid Email' : 'Send Email'}
              actionKey="send-to-email"
              buttonStyle={!isErrEmail ? buttonStyle.PRIM : buttonStyle.LARY}
              buttonSize={buttonSize.LG}
              onClick={!isErrEmail ? (actionKey) => handleSends(actionKey, options) : () => {
              }}
              customStyle={{ paddingLeft: 10, textAlign: 'center' }}
            />
            <Button
              title="Cancel send"
              actionKey="cancel-send"
              buttonStyle={buttonStyle.PRIM}
              buttonSize={buttonSize.LG}
              onClick={(actionKey) => handleSends(actionKey)}
              customStyle={{ paddingLeft: 10, textAlign: 'center' }}
            />
          </div>
        </>
      );

    case sendToName.SMS:
      return (
        <>
          <Field
            name="phone"
            placeholder="Input Phone"
            label="Phone"
            component={Input}
            className="input input--sm input--withdrop"
            isSearchable={false}
            customStyle={{backgroundColor: '#eee', paddingLeft: 10}}
          />

          <span style={{color: 'white'}}>{infoMessage.message}</span>

          <div className="m__foot__btns__dbl --gtg">
            < Button
              title={isErrPhone ? 'Enter a Valid Phone' : 'Send Text'}
              actionKey="send-to-sms"
              buttonStyle={!isErrPhone ? buttonStyle.PRIM : buttonStyle.LARY}
              buttonSize={buttonSize.LG}
              onClick={!isErrPhone ? (actionKey) => handleSends(actionKey, options) : () => {
              }}
              customStyle={{ paddingLeft: 10, textAlign: 'center' }}
            />
            <Button
              title="Cancel send"
              actionKey="cancel-send"
              buttonStyle={buttonStyle.PRIM}
              buttonSize={buttonSize.LG}
              onClick={(actionKey) => handleSends(actionKey)}
              customStyle={{ paddingLeft: 10, textAlign: 'center' }}
            />
          </div>
        </>
      );

    default:
      return null;
  }
};

export default PaycodesFormEmailOrSms;
